import React, { useRef } from 'react';

import iconProfile from 'assets/img/icons/profile.svg';
import { Container, WrapperImages } from './styles';

const Image = ({
  size = 'small', src, alt, children, row, ...props
}) => {
  const img = useRef(null);
  return (
    <Container withChildren={!!children} row={row} size={size} {...props}>
      {children || (
        <img
          ref={img}
          onError={() => {
            img.current.src = iconProfile;
          }}
          src={src}
          alt={alt}
        />
      )}
    </Container>
  );
};

export { WrapperImages };

export default Image;
